module.exports = __webpack_public_path__ + "img/portadac1.0f419ced.jpg";